import COLORS from '../../style/universal.color';
import {
    BasepathsProps,
    SelectableBasepathsSelectedProps,
} from './selectableBasepaths.types';

const {
    linkBlueOnDark,
    mlbGrey1,
    mlbGrey2,
} = COLORS;

export const buildStateObject = (
    selected: Array<SelectableBasepathsSelectedProps|string> | undefined,
): object | undefined => {
    if(!selected) {
        return undefined;
    }
    return selected.reduce((acc, element) => {
        acc[typeof element === 'object' ? element.value : element] = true;
        return acc;
    }, {});
};


export const generateColors = (
    isDark: boolean,
): BasepathsProps => {
    return {
        filledColor: linkBlueOnDark,
        strokeColor: isDark ? mlbGrey1 : mlbGrey2,
        emptyColor: isDark ? mlbGrey1 : mlbGrey2,
    };
};
